module.exports = __webpack_public_path__ + "img/krathong_6.132ebc88.png";